module.exports = __webpack_public_path__ + "static/media/photo2@2x.f86e0ea2.jpg";